/**
 * Labstep
 *
 * @module components/EntityImport/Table
 * @desc EntityImport list
 */

import { EntityImportActionMenu } from 'labstep-web/components/EntityImport/Action/Menu';
import { EntityImportProgress } from 'labstep-web/components/EntityImport/Progress';
import { ProfilePictureImagePopup as ProfilePictureImage } from 'labstep-web/components/Profile/Picture/Image';
import { Flex } from 'labstep-web/core/Flex';
import { Size } from 'labstep-web/core/Initials/types';
import { TableSimple } from 'labstep-web/core/Table/Simple';
import type { EntityImport } from 'labstep-web/models/entity-import.model';
import { humanReadableDate } from 'labstep-web/services/date.service';
import type React from 'react';
import type { EntityImportTableProps } from './types';

export const EntityImportTable: React.FC<EntityImportTableProps> = ({
  entityImports,
  actions = [],
}) => (
  <TableSimple
    id="data-import-table"
    rows={entityImports}
    columns={[
      {
        header: 'Date',
        content: (entityImport: EntityImport): React.ReactNode => (
          <>{humanReadableDate(entityImport.created_at)}</>
        ),
        cellProps: { width: 2 },
      },
      {
        header: 'Category',
        content: (entityImport: EntityImport): React.ReactNode => (
          <>{entityImport.template?.name}</>
        ),
        cellProps: { width: 2 },
      },
      {
        header: 'Status',
        content: (entityImport: EntityImport): React.ReactElement => (
          <>{entityImport.statusLabel}</>
        ),
        cellProps: { width: 2 },
      },
      {
        header: 'Progress',
        content: (entityImport: EntityImport): React.ReactElement => (
          <EntityImportProgress entityImport={entityImport} />
        ),
        cellProps: { style: { flex: 3 } },
      },

      {
        header: '',
        content: (entityImport: EntityImport): React.ReactElement => (
          <Flex
            vAlignContent="center"
            hAlignContent="right"
            spacing="gap"
          >
            <ProfilePictureImage
              size={Size.mini}
              popup
              content={entityImport.author.username}
              entity={entityImport.author}
            />
            <EntityImportActionMenu
              entityImport={entityImport}
              actions={actions}
            />
          </Flex>
        ),
      },
    ]}
  />
);
